module.exports = __webpack_public_path__ + "img/shake_shack.acedeb00.svg";